import { Decimal } from 'decimal.js';

import { NotWholeStake } from '../user/not-whole-stake';
import { PreCheckErrorMixin } from './pre-check-error';

export abstract class StakeNotDividablePreCheckBaseError extends PreCheckErrorMixin(NotWholeStake) {
    protected constructor(
        readonly exampleStakes: Decimal[],
        readonly divident: Decimal,
    ) {
        super();
    }
}
